<template>
  <v-dialog v-model="dialog" width="600px">
    <v-card>
      <v-card-title class="white--text primary">
        NỘI DUNG HỌC
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-divider></v-divider>
      <v-form ref="form" class="pa-6">
        <v-row dense align="center">
          <v-col cols="4">
            <span class="font-weight-medium">Tiết theo PPCT</span>
          </v-col>
          <v-col cols="8">
            <v-text-field
              placeholder="Nhập tiết theo PPCT"
              v-model="lessonIndex"
              dense
              outlined
              class="required"
              :rules="[$rules.required, $rules.integer]"
              @input="onLessonIndexChange"
            />
          </v-col>
        </v-row>
        <div class="mb-2 font-weight-medium">Nội dung học trên lớp</div>
        <v-select
          v-model="selectedLessonId"
          :items="lessonOptions"
          :loading="loadingTeachingPlans"
          label=""
          placeholder="Chọn nội dung"
          item-text="label"
          item-value="id"
          outlined
          dense
          clearable
        />
      </v-form>

      <v-divider></v-divider>
      <v-row class="px-6 pb-6 mt-6" no-gutters>
        <v-btn class="px-6" outlined light depressed @click="cancel">Hủy</v-btn>
        <v-spacer></v-spacer>
        <v-btn class="px-6" depressed color="primary" :loading="loading" @click="save">Lưu</v-btn>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { get } from 'lodash'

export default {
  props: {
    state: Boolean,
    lessonProp: String,
    lessonIndexProp: String,
  },
  data() {
    return {
      dialog: false,
      loading: false,
      lessonIndex: '',
      selectedLessonId: null,
      lessonOptions: [],
      loadingTeachingPlans: false,
    }
  },
  computed: {
    ...mapState('ClassNoteDetail', ['slot', 'currentTopicLesson']),
    ...mapGetters('ClassNoteDetail', ['classNoteDetailData']),
  },
  methods: {
    ...mapActions('ClassNoteDetail', ['updateLesson']),
    ...mapActions('TeachingPlan', ['getListTeachingPlanClassNote']),

    async loadTeachingPlanForClassNote() {
      this.loadingTeachingPlans = true
      try {
        const query = {
          status: 'official',
          _limit: -1,
          teacher: this.$auth.user.teacher,
          grade: get(this.slot, 'class.grade'),
          class: get(this.slot, 'class.id'),
          subject: get(this.slot, 'subject.id'),
        }

        const plans = await this.getListTeachingPlanClassNote(query)

        const lessons = []
        let count = 1
        plans.forEach(plan => {
          if (plan.topics) {
            plan.topics.forEach(topic => {
              if (topic.lessons) {
                topic.lessons.forEach(lesson => {
                  lessons.push({
                    id: lesson._id || lesson.id,
                    label: `${topic.name} - ${lesson.name}`,
                    index: count++,
                  })
                })
              }
            })
          }
        })

        this.lessonOptions = lessons

        this.selectLessonByIndex()
      } catch (e) {
        console.error(e)
        this.$alert.error('Không thể tải danh sách nội dung học')
      } finally {
        this.loadingTeachingPlans = false
      }
    },

    onLessonIndexChange(val) {
      this.lessonIndex = val
      this.selectLessonByIndex()
    },

    selectLessonByIndex() {
      const found = this.lessonOptions.find(l => String(l.index) === String(this.lessonIndex))
      if (found) {
        this.selectedLessonId = found.id
      }
    },

    async save() {
      if (!this.$refs.form.validate()) return

      this.loading = true
      try {
        const data = {
          data: {
            lessonIndex: this.lessonIndex,
          },
          topicLesson: this.selectedLessonId,
          ...this.classNoteDetailData,
        }

        console.log(data)
        await this.updateLesson(data)

        this.dialog = false
        this.$alert.updateSuccess()
      } catch (error) {
        console.error(error)
        this.$alert.updateError(error)
      } finally {
        this.loading = false
      }
    },

    cancel() {
      this.dialog = false
    },
  },

  watch: {
    state(val) {
      this.dialog = val
    },
    dialog(val) {
      if (val) {
        this.lessonIndex = this.lessonIndexProp || ''
        this.selectedLessonId = this.lessonProp || null
        this.loadTeachingPlanForClassNote()
      }
    },
  },
}
</script>
